export default {
  items: [
    {
      moduleCode: '',
      screenCode: '',
      name: 'Report Query',
      url: '/bcmreport/reportQuery/reportQuery',
      icon: 'icon-notebook',
      class: 'parent-nav',
    },
  ],
};
